import { render, staticRenderFns } from "./electronicScrollComponents.vue?vue&type=template&id=059607d6&class=full-height"
import script from "./electronicScrollComponents.vue?vue&type=script&lang=js"
export * from "./electronicScrollComponents.vue?vue&type=script&lang=js"
import style0 from "./electronicScrollComponents.vue?vue&type=style&index=0&id=059607d6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('059607d6')) {
      api.createRecord('059607d6', component.options)
    } else {
      api.reload('059607d6', component.options)
    }
    module.hot.accept("./electronicScrollComponents.vue?vue&type=template&id=059607d6&class=full-height", function () {
      api.rerender('059607d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/components/electronicScrollComponents.vue"
export default component.exports